
function csrfSafeMethod(method) {
    // these HTTP methods do not require CSRF protection
    return (/^(GET|HEAD|OPTIONS|TRACE)$/.test(method));
}

var csrftoken = Cookies.get('csrftoken');
function setCSRF() {
    $.ajaxSetup({
        beforeSend: function(xhr, settings) {
            var csrftoken2 = Cookies.get('csrftoken');
            if (!csrfSafeMethod(settings.type) && !this.crossDomain) {
                xhr.setRequestHeader("X-CSRFToken", csrftoken2);
            }
        }
    });   
}

setCSRF();


$(window).bind('csrf', function() {
   setCSRF(); 
})

$(function(){

    $('#loginForm').on('submit', function(e){
        if(e.isDefaultPrevented()){
            console.log('Form not valid')
        }else{
            e.preventDefault()
            console.log('Form valid')            
            // login(e)
        }
    })
    // $('#loginForm').submit(login);
    // $('#signUpForm').submit(signUp);
    // $('#languageSelectionForm').submit(LanguagesHandler.bind)
})
var gup = function( name, url ) {
    if (!url) url = location.href;
    name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
    var regexS = "[\\?&]"+name+"=([^&#]*)";
    var regex = new RegExp( regexS );
    var results = regex.exec( url );
    return results == null ? null : results[1];
};


function addHashToTranslation(){
    $('.js-translation-link').each(function(elem){
        href = $(this).data('url') + window.location.hash
        $(this).attr('href',href)
    })
}
if(window.location.hash!=''){
    addHashToTranslation()
}
 window.addEventListener("hashchange", addHashToTranslation, false);